<template>
  <div style="display: flex">
    <div style="flex-shrink: 0">
      <span class="md-title">
        {{ componente.value.label }}
      </span>
      <md-table>
        <md-table-row>
          <md-table-head md-numeric> Mês </md-table-head>
          <md-table-head v-for="sensor in sensoresVirtuais" :key="sensor.id">
            {{ sensor.titulo }}
          </md-table-head>
        </md-table-row>

        <md-table-row v-for="mes in meses" :key="mes">
          <md-table-cell>
            {{ mes.label }}
          </md-table-cell>

          <md-table-cell v-for="sensor in sensoresVirtuais" :key="sensor.id">
            <div v-if="!sensor.mesData[mes.label]" style="text-align: center">
              <md-progress-spinner
                :md-diameter="20"
                :md-stroke="2"
                md-mode="indeterminate"
              />
            </div>

            {{ sensor.mesData[mes.label].result }}
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
import { endOfMonth, getLastMonths } from '@/utils/dateutils'
import http from '@/utils/http'
import { extractDateByMonthAndYear } from '@/utils/transform'

export default {
  name: 'ViewShowTabelaSensorVirtualMensal',
  props: {
    localId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      meses: [],
      sensoresVirtuais: [],
      mesSensorValorMap: {},
    }
  },
  beforeMount() {
    this.loadSensoresVirtuais()
  },
  methods: {
    async loadSensoresVirtuais() {
      this.sensoresVirtuais = await http
        .get(`local/${this.localId}/sensor/virtual`)
        .then((e) =>
          (e?.sensoresVirtual ?? []).filter((x) =>
            this.componente.value.sensoresVirtuaisIds.includes(x.id)
          )
        )

      this.sensoresVirtuais.sort((a, b) => a.titulo.localeCompare(b.titulo))

      this.sensoresVirtuais = this.sensoresVirtuais.map((x) => {
        x.mesData = {}
        return x
      })

      const tasks = []

      this.meses = getLastMonths(this.componente.value.ultimosMeses).map(
        (mes) => {
          this.sensoresVirtuais.forEach((sensor) => {
            tasks.push(this.loadSensorDadaMes(sensor, mes))
          })

          return {
            label: mes,
          }
        }
      )

      await Promise.all(tasks)
    },
    async loadSensorDadaMes(sensorVirtual, mes) {
      const date = extractDateByMonthAndYear(mes)
      // TODO: Se o sensor for de persistencia nao precisa calcular
      const sensor = this.sensoresVirtuais.find(
        (x) => x.id === sensorVirtual.id
      )

      sensor.mesData[mes] = await http.get(
        `sensor/virtual/${sensorVirtual.id}/evaluate`,
        {
          horarioReferencia: endOfMonth(date),
        }
      )

      this.sensoresVirtuais = [...this.sensoresVirtuais]
    },
  },
}
</script>

<style scoped></style>
